import s from './Heart.module.css';
import PropTypes from 'prop-types';
import { HeartIcon } from 'components/iconComponent/HeartIcon';
import { HeartIconActive } from 'components/iconComponent/HeartIcon';

const HeartLabel = ({ active }) => {
  return (
    <div className={s.button}>
      {active ? <HeartIconActive /> : <HeartIcon />}
    </div>
  );
};

export { HeartLabel };

HeartLabel.propTypes = {
  active: PropTypes.bool.isRequired,
};
